import instance from '@apis/instance';
import {
    AddToCartRequest, AddToCartResponse, CartIdResponse, CartResponse, UpdateCartQuantityRequest,
} from '@models/cart';

class CartApi {
    static addToCart(shopId: string, request: AddToCartRequest): Promise<AddToCartResponse> {
        return instance.post(`/v0/shop/${shopId}/cart/item`, request);
    }

    static getCart(shopId: string, cartId: string): Promise<CartResponse> {
        return instance.get(`/v0/shop/${shopId}/cart/${cartId}`);
    }

    static getCartIdByShopId(shopId: string): Promise<CartIdResponse> {
        return instance.get(`/v0/shop/${shopId}/cart`);
    }

    static updateCartItemQuantity(
        shopId: string,
        cartId: string,
        cartItemId: string,
        request: UpdateCartQuantityRequest,
    ): Promise<never> {
        return instance.patch(`/v0/shop/${shopId}/cart/${cartId}/item/${cartItemId}/qty`, request);
    }

    static deleteCartItem(shopId: string, cartId: string, cartItemId: string): Promise<never> {
        return instance.delete(`/v0/shop/${shopId}/cart/${cartId}/item/${cartItemId}`);
    // return Promise.resolve({});
    }
}

export default CartApi;
